/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BlocksImageData interface.
 */
export function instanceOfBlocksImageData(value) {
    return true;
}
export function BlocksImageDataFromJSON(json) {
    return BlocksImageDataFromJSONTyped(json, false);
}
export function BlocksImageDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'alternativeText': json['alternativeText'] == null ? undefined : json['alternativeText'],
        'url': json['url'] == null ? undefined : json['url'],
        'caption': json['caption'] == null ? undefined : json['caption'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'ext': json['ext'] == null ? undefined : json['ext'],
        'mime': json['mime'] == null ? undefined : json['mime'],
        'size': json['size'] == null ? undefined : json['size'],
    };
}
export function BlocksImageDataToJSON(json) {
    return BlocksImageDataToJSONTyped(json, false);
}
export function BlocksImageDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'alternativeText': value['alternativeText'],
        'url': value['url'],
        'caption': value['caption'],
        'width': value['width'],
        'height': value['height'],
        'ext': value['ext'],
        'mime': value['mime'],
        'size': value['size'],
    };
}
